module.exports = [
	{
		"kind": "INTERFACE",
		"name": "Attachment",
		"possibleTypes": [
			{
				"name": "DefaultLocalAttachment"
			},
			{
				"name": "KompaProductLocalAttachment"
			},
			{
				"name": "ProductLocalAttachment"
			},
			{
				"name": "RemoteAttachment"
			}
		]
	},
	{
		"kind": "INTERFACE",
		"name": "Operation",
		"possibleTypes": [
			{
				"name": "AttachmentOperation"
			},
			{
				"name": "AuthTokenOperation"
			},
			{
				"name": "BrandOperation"
			},
			{
				"name": "ContractOperation"
			},
			{
				"name": "ContractRevisionOperation"
			},
			{
				"name": "JoinAssocOperation"
			},
			{
				"name": "LegalTextOperation"
			},
			{
				"name": "OfferOperation"
			},
			{
				"name": "OfferRevisionOperation"
			},
			{
				"name": "OrganizationOperation"
			},
			{
				"name": "ProductAccessoryOperation"
			},
			{
				"name": "ProductAvailabilityOperation"
			},
			{
				"name": "ProductCategoryOperation"
			},
			{
				"name": "ProductFamilyBundlingOperation"
			},
			{
				"name": "ProductFamilyCompatibilityOperation"
			},
			{
				"name": "ProductFamilyOperation"
			},
			{
				"name": "ProductFamilyRevisionOperation"
			},
			{
				"name": "ProductOperation"
			},
			{
				"name": "ProductRecommendationOperation"
			},
			{
				"name": "ProductRevisionOperation"
			},
			{
				"name": "ProductStyleOperation"
			},
			{
				"name": "PublicationOperation"
			},
			{
				"name": "SubjectOperation"
			},
			{
				"name": "TenantOperation"
			},
			{
				"name": "UserOperation"
			}
		]
	},
	{
		"kind": "INTERFACE",
		"name": "Paginated",
		"possibleTypes": [
			{
				"name": "Attachments"
			},
			{
				"name": "Brands"
			},
			{
				"name": "ContractRevisions"
			},
			{
				"name": "Contracts"
			},
			{
				"name": "ImportErrors"
			},
			{
				"name": "ImportReports"
			},
			{
				"name": "LegalTexts"
			},
			{
				"name": "Offers"
			},
			{
				"name": "Organizations"
			},
			{
				"name": "ProductAvailabilities"
			},
			{
				"name": "ProductCategories"
			},
			{
				"name": "ProductFamilies"
			},
			{
				"name": "ProductFamiliesActiveRevisions"
			},
			{
				"name": "ProductFamilyCompatibilities"
			},
			{
				"name": "ProductFamilyRevisions"
			},
			{
				"name": "ProductRevisions"
			},
			{
				"name": "ProductStyles"
			},
			{
				"name": "Products"
			},
			{
				"name": "Publications"
			},
			{
				"name": "Tenants"
			},
			{
				"name": "Users"
			}
		]
	},
	{
		"kind": "INTERFACE",
		"name": "Price",
		"possibleTypes": [
			{
				"name": "OfferPrice"
			},
			{
				"name": "OfferRevisionPrice"
			}
		]
	},
	{
		"kind": "INTERFACE",
		"name": "Product",
		"possibleTypes": [
			{
				"name": "BundleProduct"
			},
			{
				"name": "StandardProduct"
			}
		]
	},
	{
		"kind": "INTERFACE",
		"name": "ProductFamily",
		"possibleTypes": [
			{
				"name": "BundleProductFamily"
			},
			{
				"name": "StandardProductFamily"
			}
		]
	},
	{
		"kind": "INTERFACE",
		"name": "ProductFamilyRevision",
		"possibleTypes": [
			{
				"name": "BundleProductFamilyRevision"
			},
			{
				"name": "StandardProductFamilyRevision"
			}
		]
	},
	{
		"kind": "INTERFACE",
		"name": "ProductRevision",
		"possibleTypes": [
			{
				"name": "BundleProductRevision"
			},
			{
				"name": "StandardProductRevision"
			}
		]
	},
	{
		"kind": "INTERFACE",
		"name": "Publication",
		"possibleTypes": [
			{
				"name": "OfferPublication"
			},
			{
				"name": "OfferRevisionPublication"
			}
		]
	},
	{
		"kind": "INTERFACE",
		"name": "Revision",
		"possibleTypes": [
			{
				"name": "BundleProductFamilyRevision"
			},
			{
				"name": "BundleProductRevision"
			},
			{
				"name": "ContractRevision"
			},
			{
				"name": "OfferRevision"
			},
			{
				"name": "StandardProductFamilyRevision"
			},
			{
				"name": "StandardProductRevision"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./api/typemap.json
// module id = 556
// module chunks = 0